import { caXinyi } from './ca.xinyi';
import { caXimen } from './ca.ximen';
import { caCks } from './ca.cks';
import { caHlcity } from './ca.hlcity';
import { caTaroko } from './ca.taroko';
import { caStory } from './ca.story';
import { caAirport } from './ca.airport';
import { caKaohsiung } from './ca.kaohsiung';
import { caTainan } from './ca.tainan';
import { caBarcelona } from './ca.barcelona';
import { caGuide } from './ca.guide';
import { caWorld3 } from './ca.world3';
import { caTrips } from './ca.trips';
import { caSky } from './ca.sky';
import { caFamily } from './ca.family';
import { caClassroom } from './ca.classroom';
import { caLife } from './ca.life';
import type { Messages } from './en';
import { caTalks3 } from './ca.talks3';
import { caTreasure } from './ca.treasure';
import { caPlaces } from './ca.places';
import { caArcade } from './ca.arcade';
import { caTalks } from './ca.talks';
import { caExtra } from './ca.extra';

export const ca: Messages = {
  meta: {
    title: 'Aventura a l’institut: avui no et desmaïs!',
  },

  start: {
    title: 'Aventura a l’institut',
    tagline: 'Avui no et desmaïs!',
    blurb: 'Una setmana a la vida d’un alumne mediador de secundària: classes, família, amics… i molt de te.',
    language: 'Idioma',
    look: 'El teu aspecte',
    pet: 'Una mascota que et faci companyia',
    birthdays: 'Aniversaris (posa els teus)',
    you: 'Tu',
    mom: 'Mama',
    dad: 'Papa',
    emma: 'Emma',
    month: 'M',
    day: 'D',
    newGame: 'Partida nova',
    continue: 'Continuar',
    continueInfo: (week: number, day: string, time: string) => `Setmana ${week} · ${day} · ${time}`,
    confirmNew: 'Vols començar una partida nova? Perdràs el progrés desat.',
    controls: 'Moure’s: fletxes / WASD / tocar · Interactuar: Espai / E · Saltar: Espai / X / 🦘 · Mapa: M · Missions: Q · Menú: Esc',
  },

  looks: ['Cabell castany curt', 'Cabell negre llarg', 'Cabell vermell arrissat', 'Cua rossa'],

  pets: {
    rabbit: 'Conillet',
    cat: 'Gat',
    dog: 'Shiba',
    hedgehog: 'Eriçó',
    hamster: 'Hàmster',
    croc: 'Cocodril',
    fish: 'Peix',
    dino: 'Dino',
  },

  days: {
    fri: { name: 'Divendres', kind: 'Dia de classe' },
    sat: { name: 'Dissabte', kind: 'Cap de setmana' },
    sun: { name: 'Diumenge', kind: 'Dia de la Mare' },
  },

  zones: {
    counsel: 'Sala d’orientació',
    corridor: 'Aules',
    yard: 'Pati',
    field: 'Camp d’esports',
    home: 'Casa',
    schoolGate: 'Recinte de l’institut',
    street: 'Carrer Major',
    store: 'Botiga de la cantonada',
    park: 'Parc',
    neighborhood: 'Barri',
    classroom: 'Aula de 2n C',
    library: 'Biblioteca',
    artRoom: 'Aula d’art i música',
    lobby: 'Vestíbul',
    cafeteria: 'Menjador',
    restroom: 'Lavabos',
  },

  hud: {
    week: (n: number) => `Setmana ${n}`,
    untilBed: (h: number, mm: string) => `${h}:${mm} per anar a dormir`,
    energy: 'Energia',
    mood: 'Ànim',
    study: 'Estudi',
    bladder: 'Pipí',
    stars: 'Estrelles',
    coins: 'Monedes',
  },

  tools: {
    english: 'Shadowing',
    radio: 'Ràdio',
    art: 'Art',
    puzzle: 'Trencaclosques',
    blocks: 'Blocs',
    social: 'PixelBook',
    party: 'Festa',
  },

  side: { todo: 'Avui', bag: 'Motxilla', shop: 'Botiga', phone: 'Mòbil', menu: 'Menú', journal: 'Diari', quests: 'Missions', map: 'Mapa' },

  common: {
    ok: 'D’acord',
    close: 'Tancar',
    back: 'Tornar',
    gotIt: 'Entesos',
    cancel: 'Cancel·lar',
    yes: 'Sí',
    no: 'No',
    minutes: (n: number) => `${n} min`,
    alreadyToday: 'Això ja ho has fet avui. Prova una altra cosa!',
    me: 'Jo',
    thoughts: '(Pensant)',
    breathe: 'Respira fondo. Que avui sigui un bon dia!',
    looking: (label: string) => `Fas un cop d’ull: ${label}.`,
    stars: (n: number) => `${n > 0 ? '+' : ''}${n}⭐`,
    coins: (n: number) => `${n > 0 ? '+' : ''}${n}🪙`,
    closedToday: 'Avui no hi ha ningú: l’institut tanca els caps de setmana.',
    schoolClosed: 'L’institut és tancat el cap de setmana.',
  },

  objectives: {
    title: 'Objectius d’avui',
    allDone: 'Tots els objectius fets! Gaudeix de la resta del dia.',
    bonus: (stars: number) => `Has complert tots els objectius d’avui! Premi +${stars}⭐`,
    fri: {
      xiaoyu: 'Consolar en Xiaoyu a la sala d’orientació',
      teacher: 'Explicar a la professora Lin com està en Xiaoyu',
      log: 'Escriure el diari de mediació a l’escriptori',
      homework: 'Fer els deures a casa',
    },
    sat: {
      cookies: 'Coure galetes de nabius a casa',
      picnic: 'Fer un pícnic amb l’Emma al pati',
      dishes: 'Rentar els plats',
      sister: 'Llegir un conte a la teva germaneta',
    },
    sun: {
      strawberries: 'Comprar maduixes a la botiga',
      cake: 'Coure un pastís chiffon de maduixa',
      giveCake: 'Donar el pastís a la Mama',
      callDad: 'Trucar al Papa perquè vingui a sopar',
    },
  },

  chores: {
    title: 'Rutina de casa',
    hint: 'Ajuda a casa… la Mama s’hi fixa en tot!',
    shoes: 'Sabates i motxilla al seu lloc',
    dishes: 'Plats rentats',
    sister: 'Conte amb la germaneta',
    homework: 'Deures i shadowing fets',
    shower: 'Dutxa calenteta i pijama net',
    callDad: 'Has trucat al Papa perquè vingui a sopar',
    allTitle: '🌟 Petit exemple del dia 🌟',
    allText: 'Has completat tota la rutina de casa! La Mama et fa una abraçada enorme i et dona una mica de setmanada.',
    allClaim: 'Gràcies, Mama! (+20⭐ +50🪙)',
  },

  status: {
    tired: 'Estàs esgotat/da… busca alguna cosa per beure o un lloc per descansar.',
    bladderWarn: 'Necessites anar al lavabo ja!',
    accident: 'Oh, no… no has arribat al lavabo a temps. Quina vergonya.',
    collapseTitle: 'T’has desmaiat!',
    collapseText: 'Tot es torna negre… Et despertes al sofà dues hores després. Recorda beure i descansar!',
    xiaoyuComing: 'En Xiaoyu va cap a la sala d’orientació…',
    xiaoyuSits: 'En Xiaoyu treu una cadira i s’asseu.',
    familyTime: 'Estoneta en família! +ànim',
    lateNight: 'Es fa tard. Ves a dormir a casa per acabar el dia.',
  },

  summary: {
    title: (day: string) => `Final del ${day.toLowerCase()}`,
    starsToday: 'Estrelles guanyades',
    goals: 'Objectius complerts',
    chores: 'Rutina de casa',
    collapses: 'Vegades que t’has desmaiat',
    mood: 'Ànim final',
    momLove: 'Afecte de la Mama',
    next: 'Dormir i començar el dia següent',
    weekTitle: (week: number) => `Setmana ${week} completada!`,
    weekText: (stars: number, rank: string) => `Estrelles totals: ${stars}. Rang: ${rank}.`,
    ranks: ['Vas pel bon camí', 'Bona gent', 'Estrella mediadora', 'Llegenda de l’institut'],
    nextWeek: 'Començar la setmana següent',
  },

  sleep: {
    label: 'Llit',
    title: 'El teu llit calentó',
    early: 'És massa d’hora per dormir. Una migdiadeta?',
    nap: 'Migdiada de 30 minuts (+energia)',
    sleep: 'Anar a dormir (acabar el dia)',
    stay: 'Encara no',
  },

  menu: {
    title: 'Menú',
    resume: 'Continuar',
    language: 'Idioma',
    sound: (on: boolean) => `So: ${on ? 'sí' : 'no'}`,
    voice: (on: boolean) => `Veus: ${on ? 'sí' : 'no'}`,
    endDay: 'Acabar el dia ara',
    endDayConfirm: 'Saltar al final del dia?',
    newGame: 'Partida nova',
    save: 'Desar partida',
    saved: 'Partida desada.',
  },

  bag: {
    title: '🎒 La meva motxilla',
    use: 'Fer servir',
    empty: 'La motxilla és buida.',
    items: {
      tea: { name: 'Bossa de te', desc: 'Beure: +12 d’energia' },
      orange: { name: 'Mandarina', desc: 'Menjar: +10 d’energia' },
      candy: { name: 'Caramel de fruita per a la gola', desc: 'Menjar: +4 d’ànim. Un bon regal.' },
      cookies: { name: 'Galetes de nabius', desc: 'Menjar: +8 d’energia, +6 d’ànim. Ideals per compartir.' },
      cake: { name: 'Pastís chiffon de maduixa', desc: 'Un regal de tot cor.' },
      strawberries: { name: 'Maduixes', desc: 'Per coure un pastís.' },
      book: { name: 'Llibre il·lustrat', desc: 'Per a l’hora del conte.' },
      water: { name: 'Ampolla d’aigua', desc: 'Beure: +6 d’energia (omple-la a la font)' },
      riceBall: { name: 'Bola d’arròs', desc: 'Menjar: +15 d’energia' },
      juice: { name: 'Brik de suc', desc: 'Beure: +10 d’energia' },
      atlas: { name: 'Atles del món', desc: 'L’atles que falta a la biblioteca.' },
      kite: { name: 'Estel', desc: 'L’estel vermell d’en Bo.' },
      kitten: { name: 'La Mochi, la gateta', desc: 'La gateta de l’àvia Lee. Et va seguint!' },
      letter: { name: 'Carta', desc: 'La carta de la Mama per a l’àvia Lee.' },
    },
    used: (name: string) => `Has fet servir: ${name}`,
    emptyBottle: 'L’ampolla és buida: omple-la a la font d’aigua.',
  },

  shop: {
    title: '🛒 Cooperativa de l’institut',
    hint: 'Paga amb monedes. Les guanyes ajudant a casa i resolent trencaclosques.',
    buy: 'Comprar',
    bought: (name: string) => `Has comprat: ${name}`,
    poor: 'No tens prou monedes!',
  },

  objects: {
    desk: 'Taula de mediació',
    tea: 'Racó del te i el cacau',
    water: 'Font d’aigua',
    shelf: 'Prestatgeria',
    plant: 'Planta en test',
    sofa: 'Sofà',
    toilet: 'Lavabo',
    easel: 'Cavallet',
    chineseDesk: 'Taula d’escriptura',
    piano: 'Piano de cua',
    board: 'Tauler d’anuncis',
    field: 'Jardí exterior',
    bench: 'Banc',
    shoes: 'Sabater',
    sink: 'Pica de la cuina',
    oven: 'Forn',
    homeDesk: 'Escriptori',
    bath: 'Bany',
    bed: 'Llit',
    picnic: 'Estovalles de pícnic',
    atlasDesk: 'Pupitre',
    libShelf: 'Prestatge de la biblioteca',
    vending: 'Màquina expenedora',
    canteen: 'Barra del menjador',
    busStop: 'Parada d’autobús',
    mailbox: 'Bústia',
    pond: 'Estany',
    bush: 'Arbust',
    kiteTree: 'Arbre gran',
    swing: 'Gronxador',
    fridge: 'Nevera',
    tv: 'Tele',
    shopCounter: 'Taulell',
  },

  npc: {
    chunbo: 'L’oncle Chun',
    emma: 'Emma',
    teacher: 'La professora Lin',
    xiaoyu: 'Xiaoyu',
    mom: 'Mama',
    sister: 'Germaneta',
    dad: 'Papa',
    librarian: 'La senyora Wang',
    rain: 'Rain',
    coach: 'L’entrenador Hsu',
    clerk: 'Kai',
    grandma: 'L’àvia Lee',
    bo: 'Bo',
    cat: 'Gat',
  },

  desk: {
    text: 'La pantalla mostra l’horari de mediació i les notes d’avui.',
    log: 'Escriure el diari de mediació',
    logDone: 'Diari desat: «En Xiaoyu (2n d’ESO) sovint sembla cansat per problemes a casa. Paciència i amabilitat».',
    english: 'Obrir la pràctica de shadowing',
    schedule: 'Veure els objectius d’avui',
  },

  tea: {
    text: 'La tetera fumeja suaument. Fa olor d’ordi torrat i de cacau.',
    drink: 'Preparar-te un cacau calent (+18 d’energia)',
    drinkToast: 'Calentó i dolç: estàs ben despert/a!',
    share: 'Preparar una tetera per compartir (+3 bosses de te)',
    shareToast: 'Guardes 3 bosses de te per regalar.',
    watch: 'Mirar com degota (+6 d’ànim)',
    watchToast: 'Plic… plic… que relaxant.',
  },

  water: {
    text: 'Una font blava i transparent amb aixeta d’aigua freda i calenta.',
    cold: 'Aigua freda (+6 d’energia)',
    coldToast: 'Glu, glu… que fresqueta!',
    hot: 'Te calent (+8 d’ànim)',
    hotToast: 'Una tassa de te calentó et reconforta.',
    refill: 'Omplir l’ampolla',
    refillToast: 'Ampolla plena!',
  },

  shelf: {
    text: 'Fileres de llibres de colors: vermells, blaus, verds i daurats.',
    read: 'Llegir «La psicologia de l’autodisciplina» (+8 d’estudi)',
    readToast: 'La disciplina no és una gàbia: és el volant de la teva pròpia vida!',
    borrow: 'Agafar en préstec un llibre il·lustrat per a la germaneta',
    borrowToast: 'Tens un llibre il·lustrat!',
    english: 'Obrir la pràctica de shadowing',
  },

  plant: {
    text: 'Fulles de tres tons de verd en un test de terrissa.',
    water: 'Ruixar les fulles (+6 d’ànim)',
    waterToast: 'Les gotetes brillen sobre les fulles.',
    prune: 'Treure les fulles velles i remoure la terra',
    pruneToast: 'La planta es veu sana i feliç!',
  },

  sofa: {
    text: 'Un sofà beix ben tou, perfecte per fer un descans.',
    nap: 'Tancar els ulls 20 minuts (+energia, +ànim)',
    napToast: 'Et sents en calma i amb les piles carregades.',
  },

  toilet: {
    notNeeded: 'Ara mateix no necessites anar al lavabo.',
    done: 'Ahhh, molt millor!',
  },

  art: {
    title: 'Aula d’art · Cavallet',
    text: 'Al cavallet hi diu **els sis pilars del bon gust visual**:\n1. **Forma**: contorn i proporció\n2. **Color**: harmonia, càlids i freds\n3. **Textura**: veta de la fusta, tela, tacte\n4. **Composició**: equilibri, espai en blanc, ritme\n5. **Estructura**: ordre i suport\n6. **Pràctica diària**: observar → recopilar → imitar → crear',
    quiz: '🎨 Test de barreja de colors',
    quizQ: 'Si barreges blau cobalt i groc llimona a parts iguals, què obtens?',
    quizA: ['Verd herba fresca', 'Violeta fosc', 'Mandarina intens'],
    quizRight: 'Correcte! Blau + groc = verd.',
    quizWrong: ['Això és blau + vermell. Torna-ho a provar!', 'Això és vermell + groc!'],
    steps: '🖼️ La pràctica en quatre passos',
    stepsText: '① **Observar**: fixa’t en l’equilibri, el contrast i l’harmonia\n② **Recopilar**: fes fotos de colors i composicions que t’agradin\n③ **Imitar**: prova aquestes paletes a la teva habitació o a la roba\n④ **Crear**: desenvolupa el teu propi estil!',
    stepsClaim: 'Entesos! (+5⭐)',
  },

  writing: {
    title: 'Taula d’escriptura',
    text: 'A la pissarra hi ha estructures de frases per enllaçar idees.',
    a: '✍️ Frases amb «Encara que…, …»',
    aQ: 'Tria la frase que té sentit:',
    aGood: 'Encara que plovia a bots i barrals, vam arribar a l’institut a temps i plens d’energia.',
    aBad: 'Encara que vaig esmorzar, tenia la panxa plena.',
    aRight: 'Fluida i lògica!',
    aWrong: 'El contrast de l’«encara que» no acaba de funcionar aquí. Pensa-hi una altra vegada!',
    b: '✍️ Frases amb «No només…, sinó també…»',
    bQ: 'Tria la millor frase:',
    bGood: 'En Xiaoyu no només va parlar del que el preocupava, sinó que també va llegir un text en anglès en veu alta!',
    bBad: 'En Xiaoyu no només estava cansat, sinó que també el cel és blau.',
    bRight: 'Una frase genial!',
    bWrong: 'Les dues meitats no es complementen.',
  },

  piano: {
    title: 'Aula de música · Piano de cua',
    text: 'Les tecles brillen en negre i ivori sota el sol.',
    free: '🎹 Tocar lliurement',
    freeText: 'Toca una tecla perquè soni:',
    played: (note: string) => `♪ ${note}`,
    finish: 'Acabar la pràctica (+3⭐)',
    ear: '👂 Prova d’oïda',
    earQ: 'Quina nota acabes de sentir?',
    replay: '🔁 Tornar-la a tocar',
    note: (n: string) => `Nota ${n}`,
    right: 'Oïda absoluta!',
    wrong: (n: string) => `Era ${n}. Continua practicant!`,
  },

  catchBall: {
    title: 'Pilota alta al jardí',
    text: (wind: string) => `Una pilota alta travessa el cel! El vent bufa ${wind}.`,
    winds: { left: 'cap a l’esquerra', right: 'cap a la dreta', none: 'molt fluixet' },
    left: 'Córrer cap a l’esquerra',
    right: 'Córrer cap a la dreta',
    stay: 'Quedar-se quiet i esperar',
    caught: 'Quina parada! El públic t’aclama!',
    missed: 'La pilota cau just fora del teu abast. Per un pèl!',
  },

  board: {
    title: 'Tauler d’anuncis',
    text: 'Notes clavades: «Els alumnes mediadors es reuneixen a la sala d’orientació. Sigues amable, vés amb compte i demana ajuda».',
  },

  bench: {
    text: 'Un banc de fusta sota els arbres.',
    rest: 'Seure a escoltar els ocells (+ànim)',
    restToast: 'La brisa fa moure les fulles. Quina pau.',
  },

  oven: {
    title: 'Cuina · Forn',
    text: 'El forn brilla amb un taronja càlid. La farina i la mantega esperen al taulell.',
    cookies: '🍪 Coure galetes de nabius',
    cookiesWork: 'Barrejant, fent boletes, coent…',
    cookiesDone: 'Ding! Ja hi ha 3 galetes de nabius a punt!',
    cake: '🍰 Coure un pastís chiffon de maduixa',
    cakeNeeds: 'Primer necessites maduixes: compra’n a la cooperativa.',
    cakeWork: 'Muntant el merengue, coent, decorant…',
    cakeDone: 'Quina olor! Un pastís chiffon de maduixa!',
  },

  mom: {
    lines: [
      'La Mama et despentina amb carinyo. «Cansat/da? Què tal avui a l’institut?»',
      'La Mama somriu. «Avui el rebedor està molt endreçat. T’estàs fent gran!»',
      'La Mama està plegant la roba. «Et ve de gust alguna cosa especial per sopar?»',
    ],
    giveCake: '🎁 Donar a la Mama el pastís de maduixa',
    giveCakeNone: 'Encara no tens cap pastís a la motxilla. Cou-ne un al forn!',
    giveCakeReply: 'De debò l’has fet per a mi? És boníssim… Que feliç i que emocionada estic!',
    giveCookies: '🎁 Donar unes galetes a la Mama',
    giveCookiesNone: 'No tens galetes a la motxilla. Primer cou-ne algunes!',
    giveCookiesReply: 'Que cruixents! Gràcies, carinyo.',
    hug: 'Abraçar la Mama: «Gràcies per tot. T’estimo!»',
    hugReply: 'Veure’t sa/na, feliç i responsable és tot el que necessito.',
    tired: 'La Mama somriu. «Avui ja ens hem fet l’abraçada. Ves a descansar, carinyo».',
    helpOpt: 'Necessites ajuda, Mama?',
    letter: 'Podries portar aquesta carta a l’àvia Lee? Sol estar al parc, a prop de l’estany.',
  },

  shoes: {
    text: 'Per fi a casa. Hora de treure’s les sabates i deixar la motxilla.',
    act: 'Posar bé les sabates i penjar la motxilla',
    done: 'Tot al seu lloc. La Mama se n’ha adonat!',
  },

  sink: {
    text: 'Les carmanyoles i els plats del sopar esperen a la pica.',
    act: 'Rentar els plats i les carmanyoles',
    done: 'Ben lluents! La Mama diu que ets un sol.',
  },

  sister: {
    text: 'La teva germaneta ve corrents amb les joguines. «Ja ets a casa!»',
    read: 'Llegir-li un llibre il·lustrat',
    readNoBook: 'No tens cap llibre il·lustrat. Agafa’n un en préstec de la prestatgeria de la sala d’orientació.',
    readDone: 'Riu durant tot el conte. La Mama somriu des de la porta.',
    puzzle: 'Fer junts un trencaclosques lliscant',
  },

  homeDesk: {
    text: 'Un escriptori endreçat i un llum de llum suau.',
    act: 'Fer els deures i després una mica de shadowing',
    done: 'Deures fets! La Mama està orgullosa de tu.',
  },

  bath: {
    text: 'De la banyera calenteta en surt vapor.',
    shower: 'Dutxar-te i posar-te el pijama net',
    showerDone: 'Fresquet, net i a gust!',
    toilet: 'Anar al vàter',
  },

  dad: {
    hello: 'El Papa s’afluixa la corbata. «He arribat a temps per sopar, tal com et vaig prometre!»',
    hug: 'Fer una abraçada al Papa',
    hugReply: 'Aquesta és la millor benvinguda.',
  },

  xiaoyu: {
    title: 'Xiaoyu · 2n d’ESO',
    open: '…Avui no tinc gens de ganes d’anar a classe.',
    sitDown: 'Seu una estona amb mi. Vols un cacau calent?',
    tired: '…Els meus pares es van tornar a barallar fins tard. Estic molt cansat. I tinc por.',
    safe: 'Aquí estàs segur. Queda’t tot el que necessitis, jo em quedo amb tu.',
    english: 'Vols que llegim alguna cosa en anglès junts per distreure’t?',
    better: '…Gràcies. Em sento una mica millor. Intentaré tornar per a la segona hora.',
    promise: 'Ens tornem a veure després de dinar, d’acord?',
    done: 'Ara en Xiaoyu confia en tu.',
    candy: 'Oferir-li un caramel per a la gola',
    candyNone: 'No tens caramels per a la gola.',
    candyDone: 'En Xiaoyu agafa el caramel i assenteix.',
    later: 'En Xiaoyu et saluda amb la mà de camí a classe.',
    satHello: '…Ah, hola. Avui no volia quedar-me a casa. Només estic aquí assegut.',
    satInvite: 'L’Emma i jo fem un pícnic. Vols venir?',
    satAccept: 'De debò? Només si a l’Emma li sembla bé…',
    satJoined: 'Feia molt de temps que no m’ho passava tan bé un cap de setmana. Gràcies.',
    askEmma: 'Pot venir en Xiaoyu al nostre pícnic?',
    emmaYes: 'És clar! Com més serem, més riurem. Li guardo un entrepà!',
  },

  teacher: {
    before: 'Has vist en Xiaoyu? Aquest matí no ha vingut a classe. Estic preocupada.',
    report: 'Dir-li que en Xiaoyu ja està tranquil i que tornarà per a la segona hora',
    thanks: 'Moltíssimes gràcies. Tenir alumnes mediadors com tu marca la diferència.',
    after: 'Gràcies una altra vegada per cuidar avui d’en Xiaoyu.',
  },

  chunbo: {
    title: 'L’oncle Chun · Conserge',
    versions: [
      {
        intro: 'Bon dia, xicot! Tot tranquil a la meva ronda. Després passa a prendre un te!',
        give: 'Bon dia, oncle Chun! Prengui alguna cosa calenta',
        learn: 'Demanar-li consells de seguretat per l’institut',
      },
      {
        intro: 'Abans hi havia un desconegut repartint fullets a la porta. L’he fet marxar. Aneu amb compte!',
        give: 'Gràcies per cuidar-nos! Tingui, un detallet',
        learn: 'Preguntar-li què fer amb els desconeguts',
      },
      {
        intro: 'Quin dia més bonic! Veure-us tan plens d’energia em fa sentir jove una altra vegada.',
        give: 'Avui fa molt bona cara! Tingui, un regalet',
        learn: 'Xerrar sobre les flors del pati',
      },
    ],
    gotTea: 'L’oncle Chun fa un glop de te i somriu d’orella a orella!',
    gotCandy: 'L’oncle Chun es posa el caramel a la boca. «Ah, que bé que em va per a la gola!»',
    gotNothing: 'Saludes l’oncle Chun amb alegria.',
    hungryOpt: 'Fa cara de cansat, oncle Chun. Va tot bé?',
    hungry: 'Ja, ja, te n’has adonat! M’he saltat l’esmorzar i no puc deixar la porta. La panxa em fa uns sorolls…',
    riceAccept: 'Li porto una bola d’arròs de la botiga!',
    riceGive: 'Donar la bola d’arròs a l’oncle Chun 🍙',
    riceThanks: 'Ah, encara és calenteta! M’has salvat la vida. Passa per la garita quan vulguis!',
    tipTitle: 'El consell de l’oncle Chun',
    tip: 'No et posis a parlar amb desconeguts que se t’acostin i no acceptis mai menjar ni beguda de gent que no coneixes. La seguretat, el primer!',
    remember: 'Me’n recordaré!',
  },

  emma: {
    lines: [
      'Ei! Practiquem junts la pronunciació en anglès?',
      'Hola! Has escoltat avui la ràdio en anglès? La música era genial!',
      'Bon dia! Has acabat els deures? Podem estudiar junts!',
    ],
    picnicLine: 'Has vingut! He portat unes estovalles i suc. Tu has portat alguna cosa per compartir?',
    english: 'És clar! Fem shadowing',
    radio: 'Escoltem la ràdio',
    cookies: 'Donar-li unes galetes',
    cookiesNone: 'No tens galetes a la motxilla. Primer cou-ne algunes a casa!',
    cookiesReply: 'Ala, galetes casolanes! Fan una olor boníssima! Gràcies!',
    picnicShare: 'Compartir les teves galetes casolanes',
    picnicNone: 'Encara no tens res per compartir… primer cou galetes a casa!',
    picnicTitle: '🧺 Pícnic de cap de setmana',
    picnicDone: 'L’Emma i tu compartiu galetes a la gespa mentre sona música. Una tarda perfecta!',
    absent: 'Ara mateix l’Emma no és per aquí.',
  },

  calls: {
    incoming: 'Trucada entrant',
    answer: 'Respondre',
    decline: 'Rebutjar',
    declined: 'Trucada rebutjada.',
    pool: {
      scamStock: {
        caller: 'Desconegut · «Assessors d’Inversió»',
        desc: '0982-xxx-xxx (trucada comercial)',
        intro: 'Hola! Som una empresa d’inversió líder. Un 30 % de benefici cada setmana, garantit! Afegeix-nos al xat ara i et donem consells de borsa gratis!',
        good: 'Penjar i denunciar-ho a la línia antifrau 165',
        goodMsg: 'Molt espavilat/da! És una estafa d’inversió de manual.',
        bad: '«De debò? Sense cap risc?»',
        badMsg: 'Compte! Prometre beneficis enormes és un senyal d’alarma: gairebé els dones el teu compte.',
      },
      scamGame: {
        caller: 'Sospitós · «Suport del joc»',
        desc: 'Diu que has guanyat una skin llegendària gratis',
        intro: 'Enhorabona, jugador! Has guanyat una skin llegendària limitada! Només ens has de dir la teva contrasenya i el codi SMS perquè te l’afegim!',
        good: 'Negar-t’hi i penjar',
        goodMsg: 'Exacte! El personal de debò mai no demana contrasenyes ni codis.',
        bad: 'Llegir-los el codi SMS',
        badMsg: 'Oh, no! T’han robat el compte just després de donar-los el codi.',
      },
      insurance: {
        caller: 'Comercial · «Assegurances Vida Segura»',
        desc: 'Ven un pla d’estalvi',
        intro: 'Hola! Tens dos minuts? La nostra nova assegurança d’estalvi dona molt bons rendiments, i t’emportes un regal!',
        good: '«Gràcies, però soc menor d’edat. Ho parlaré amb els meus pares».',
        goodMsg: 'Educat i assenyat! Les decisions de diners són cosa de tota la família.',
        bad: 'Cridar-los i penjar',
        badMsg: 'Una mica impulsiu… el teu ànim baixa.',
      },
      mom: {
        caller: 'Mama ❤️',
        desc: 'Només vol saber com estàs',
        intro: 'Carinyo, ha refrescat… t’has endut la jaqueta? Has dinat bé?',
        good: '«Sí, Mama! Vaig abrigat/da i he menjat molt. Cuida’t tu també!»',
        goodMsg: 'A la Mama se li fon el cor. Sents l’escalfor de casa.',
        bad: '«Sí, sí, estic enfeinat/da, adeu».',
        badMsg: 'La Mama sospira fluixet a l’altra banda…',
      },
      friend: {
        caller: 'En Jay, el teu millor amic 🏀',
        desc: 'Truca pel que fareu després de classe',
        intro: 'Ei! El gimnàs està lliure després de classe! Practiquem triples? Tinc pilota nova!',
        good: '«Som-hi! Ens veiem a la pista!»',
        goodMsg: 'Amics per sempre! Estàs a tope!',
        bad: '«Primer acabo les tasques de mediació. Demà?»',
        badMsg: 'Decisió responsable! En Jay diu que demà ja li va bé.',
      },
    },
  },

  phone: {
    tabs: { chats: '💬 Xats', calls: '📞 Trucades', feed: '🌐 Mur', radio: '📻 Ràdio' },
    chatsTitle: 'Xats',
    placeholder: 'Escriu un missatge…',
    now: 'ara',
    yesterday: 'Ahir',
    send: 'Enviar',
    stickers: 'Adhesius',
    defaultReply: 'Missatge rebut! Que tinguis un dia genial!',
    chats: {
      family: {
        name: 'Família (4)',
        preview: 'El Papa ha enviat una postal de bon dia',
        msgs: [
          { from: 'Papa', text: '@card' },
          { from: 'Mama', text: 'Aneu amb compte tots. Que tingueu un bon dia!' },
          { from: 'Germaneta', text: 'Bon dia! Juguem quan tornis a casa?' },
        ],
        choices: [
          'Respondre: Bon dia! Arribaré a temps per sopar.',
          'Enviar una postal de bon dia 🌸',
          'Respondre a la germaneta: Espera’m, que et llegiré un conte i farem un trencaclosques!',
        ],
        r1: [
          { from: 'Mama', text: 'Que bé! Et faré el teu plat preferit.' },
          { from: 'Papa', text: 'Jo també arribaré a temps!' },
        ],
        r1more: 'Visca, quines ganes de sopar!',
        cardReply: { from: 'Papa', text: 'Ja, ja, quina postal més bonica! Que tinguis un dia ple d’energia!' },
        r3: [
          { from: 'Germaneta', text: 'Visca! Ets el millor del món! 🎉' },
          { from: 'Mama', text: 'Que macos que sou tots dos.' },
        ],
        replies: ['Entesos! Cuideu-vos molt tots!', 'Que tingueu un dia feliç!'],
      },
      friends: {
        name: 'Millors amics (3)',
        preview: 'Jay: pícnic o bàsquet aquest cap de setmana?',
        msgs: [
          { from: 'Jay', text: 'Bé, pícnic o bàsquet aquest cap de setmana? 🏀' },
          { from: 'Rain', text: 'Pícnic! Qui porta el berenar? 🍰' },
          { from: 'Ming', text: 'No us oblideu de mirar com està en Xiaoyu, el de 2n C!' },
        ],
        choices: [
          'A la Rain: Faré galetes de nabius per al pícnic!',
          'Al Ming: En Xiaoyu està tranquil a la sala d’orientació, no pateixis.',
          'Al Jay: Primer pícnic i després un 3 contra 3!',
        ],
        r1: [
          { from: 'Rain', text: 'Síííí! Ets un geni de la rebosteria! 🍰' },
          { from: 'Jay', text: 'Primer menjar i després pilota. Pla perfecte!' },
        ],
        r2: { from: 'Ming', text: 'Gràcies! Quina sort que hi siguis.' },
        r3: { from: 'Jay', text: 'Fet! El millor cap de setmana de la història.' },
      },
      mom: {
        name: 'Mama ❤️',
        preview: 'Recorda beure aigua i esmorzar',
        msgs: [
          { from: '', text: 'Fa fred: posa’t la jaqueta i dina bé.' },
          { from: '', text: 'Si has d’arribar tard, envia’m un missatge.' },
        ],
        choices: ['Respondre: D’acord, Mama ❤️ Menjaré bé i tornaré a l’hora!', 'Enviar una postal de bon dia 🌸'],
        r1: 'Així m’agrada! Vés amb compte pel camí.',
        replyMorning: 'Bon dia! Beu una mica d’aigua tèbia i esmorza.',
        replyLove: 'Jo també t’estimo! Torna aviat aquesta nit ❤️',
        replyOther: 'D’acord, entesos. Cuida’t a l’institut!',
        kwMorning: ['dia', 'esmorz', 'menjar', 'dinar'],
        kwLove: ['estimo', "t'estimo", 't’estimo', '❤'],
      },
      emma: {
        name: 'Emma',
        preview: 'Practiquem shadowing?',
        msgs: [{ from: '', text: 'Ei! A punt per practicar shadowing?' }],
        choices: ['Sí! Practiquem ara mateix.', 'Em dones una paraula difícil?'],
        r1me: 'Sí! Obro ara la llibreta de shadowing!',
        r1: 'Genial! A per la perfecció! 💪',
        r2me: 'Em dones una paraula difícil per practicar?',
        r2: 'Prova amb «responsibility» i «resilient»! 🌟',
        replies: ['Entesos! Continuem aprenent!', 'Genial! La pràctica fa el mestre!'],
      },
    },
    card: [
      { top: '🌸😊🌸', big: 'Bon dia', sub: 'Comença el dia amb un somriure\nEt desitjo salut i sort' },
      { top: '☀️🌻✨', big: 'Pau i alegria', sub: 'Que tot et surti bé\nAvui, a tope d’energia!' },
    ],
    stickerLines: ['🌸 Que tinguis un dia preciós!', '☀️ Un raig de sol per a tu!', '🌈 Bon rotllo!', '❤️ Us estimo', '💪 Podem amb tot!', '👍 Em sembla bé!', '😂 Ja, ja, ja!', '🙏 Gràcies!'],
    callList: {
      title: '📞 Contactes',
      mom: { name: 'Mama', sub: 'Trucada familiar' },
      dad: { name: 'Papa', sub: 'Demanar-li que vingui a sopar' },
      friend: { name: 'En Jay, el teu millor amic', sub: 'Plans per al cap de setmana' },
      hotline: { name: 'Línia antifrau 165', sub: 'Comprovar si una cosa és una estafa' },
    },
    call: {
      connecting: 'Connectant…',
      inCall: 'En trucada',
      hangUp: '🔴 Penjar',
      mom: {
        line: 'Hola, carinyo? Vés amb compte de tornada a casa, estic fent el teu sopar preferit!',
        a: '«Mama, ja soc de camí!»',
        b: '«T’estimo, Mama! T’ajudo a parar taula i a rentar els plats!»',
        ra: 'D’acord, fins ara. Vés amb compte!',
        rb: 'Que atent que ets! N’estic molt orgullosa.',
      },
      dad: {
        line: 'Digui? Acabo de sortir d’una reunió. Què passa?',
        a: '«Papa, torna a temps i sopa amb nosaltres!»',
        b: '«No treballis tant, Papa. Torna aviat!»',
        reply: 'Com que m’ho demanes tan bé, recullo i vinc a casa a sopar!',
      },
      friend: {
        line: 'Ei! Aquest cap de setmana fem pícnic i bàsquet. Portes el teu famós berenar?',
        a: '«És clar que sí! Marxant galetes de nabius!»',
        b: '«Ens veiem a la pista!»',
        reply: 'Genial! Tothom t’espera al grup!',
      },
      hotline: {
        line: 'Ha trucat a la línia antifrau 165. Els cobraments inesperats o els desconeguts que demanen contrasenyes són sempre una estafa.',
        a: '«Entesos, estaré alerta. Gràcies, agent!»',
        reply: 'Molt bona consciència antifrau! Que tinguis un dia segur!',
      },
    },
    feed: {
      brand: 'PixelBook',
      tagline: 'Navega amb seguretat',
      post: '📷 Publicar una foto',
      rules: '🛡️ Normes de seguretat',
      report: '🔒 Denunciar i bloquejar',
      interact: 'Clicar',
      reported: '✅ Denunciat i bloquejat',
      like: '👍 M’agrada',
      liked: '❤️ T’agrada',
      comment: '💬 Comentar',
      commented: 'Has respost a la Rain!',
      reportOk: 'Ben fet! T’has protegit a tu i als teus amics.',
      reportBad: 'Arriscat! Clicar enllaços sospitosos és com es cau en les estafes.',
      likeOn: 'T’agrada!',
      likeOff: 'Ja no t’agrada',
      posts: {
        scam1: {
          author: 'Desconegut «MagnatGamer»',
          time: 'fa 5 min',
          tag: '⚠️ Sol·licitud d’un desconegut',
          content: 'Hola! Afegeix-me i et regalo 5000 punts de joc. Només m’has d’enviar per privat una captura del teu inici de sessió!',
        },
        scam2: {
          author: 'Grup «MÒBILS GRATIS»',
          time: 'fa 25 min',
          tag: '⚠️ Pesca de dades',
          content: 'Oferta limitada! Clica l’enllaç i escriu el telèfon i el número de targeta dels teus pares per guanyar un mòbil gratis!',
        },
        rain: {
          author: 'La Rain, la teva millor amiga 📚',
          time: 'fa 1 h',
          tag: '🌿 Vida a l’institut',
          content: 'Avui he repassat vocabulari d’anglès a la biblioteca, que productiu! Algú s’apunta a un pícnic aquest cap de setmana? 🥪',
        },
        mine: {
          author: 'Jo',
          time: 'ara mateix',
          tag: '🍰 Rebosteria',
          content: 'He fet un pastís chiffon de maduixa després de classe! A tota la família li ha encantat~',
        },
      },
      photoTitle: '📷 Publicació nova',
      photoText: 'Què vols compartir? (Pensa en la teva privacitat!)',
      photoCake: '🍰 El meu pastís acabat de fer',
      photoCakeDone: 'Publicat! Als teus amics els està agradant.',
      photoDoor: '🏠 La porta de casa meva amb el número',
      warnTitle: '⚠️ Avís de seguretat!',
      warnText: 'No publiquis mai fotos on es vegi el número de casa teva, el portal o les claus! Un desconegut les podria fer servir per saber on vius.',
      warnFix: 'Amagar el número i publicar una foto de l’institut',
      warnFixed: 'Molt bé, has protegit la teva adreça!',
      rulesTitle: '🛡️ Normes de seguretat a internet',
      rulesText: '**1. No acceptis desconeguts.** Els perfils a internet poden ser falsos.\n\n**2. La teva informació personal és privada.** El teu nom complet, telèfon, adreça i classe no es publiquen mai.\n\n**3. Les contrasenyes són secretes.** Qui t’ofereix coses gratis a canvi de la teva contrasenya o codi és un estafador.\n\n**4. Si alguna cosa no et fa bona espina, demana ajuda.** Explica-ho de seguida als teus pares o a un profe.',
      rulesClaim: 'Me les sé de memòria! (+5⭐)',
    },
    radio: {
      title: '📻 Ràdio per aprendre',
      text: 'Tria alguna cosa per escoltar (s’obre YouTube):',
      a: { name: 'mebook888 anglès diari', sub: 'Conversa i comprensió oral' },
      b: { name: 'Llista de pop en anglès', sub: 'Cançons alegres per taral·lejar' },
      c: { name: 'Ciència per a nens en anglès', sub: 'Aprèn ciència i anglès' },
      opened: 'Obert en una pestanya nova.',
    },
  },

  english: {
    title: '📚 Shadowing d’anglès',
    hint: '🔊 Escolta → 🎤 Repeteix → ✅ Guanya estrelles',
    listen: '🔊 Escoltar',
    practice: '🎤 Practicar',
    sayIt: (w: string) => `Digues-ho clar i en veu alta: **${w}**`,
    listening: '🎤 Escoltant… digues la paraula ara',
    heard: (s: string) => `He sentit: «${s}»`,
    match: 'Molt bona pronunciació!',
    noMatch: 'Gairebé… torna-la a escoltar i torna-ho a provar.',
    selfCheck: '✅ Ho he dit clar',
    tryMic: '🎤 Comprovar amb el micròfon',
    again: '🔁 Tornar a escoltar',
    noMic: 'Micròfon no disponible: fes servir el botó d’autocomprovació.',
    meanings: {
      responsibility: 'responsabilitat',
      empathize: 'entendre els sentiments dels altres',
      discipline: 'autocontrol, disciplina',
      resilient: 'capaç de refer-se',
      boundary: 'un límit personal',
      procrastinate: 'deixar les coses per a més tard',
      cyberbullying: 'assetjament per internet',
    },
  },

  blocks: {
    title: '🧱 Torre de blocs',
    score: 'Punts',
    lines: 'Línies',
    level: 'Nivell',
    next: 'Següent',
    restart: 'Reiniciar',
    quit: 'Sortir',
    over: 'Fi de la partida',
    cleared: (n: number) => (n === 1 ? '1 línia completada!' : `${n} línies completades!`),
    quad: '💥 Quatre línies alhora!',
    capped: 'Has arribat al límit diari d’estrelles d’aquest joc. Juga només per divertir-te!',
    final: (score: number) => `Puntuació final: ${score}`,
  },

  puzzle: {
    title: '🧩 Trencaclosques lliscant',
    hint: 'Toca una peça al costat del forat. Ordena de l’1 al 8!',
    shuffle: 'Barrejar',
    moves: (n: number) => `Moviments: ${n}`,
    solved: '🎉 Trencaclosques resolt!',
  },

  radio: {
    title: '📻 Ràdio en anglès',
  },

  party: {
    title: '🎂 Festes d’aniversari',
    text: 'De qui celebrem l’aniversari? (Cada festa necessita un pastís!)',
    me: (d: string) => `🎉 El meu aniversari (${d})`,
    mom: (d: string) => `💐 L’aniversari de la Mama (${d})`,
    dad: (d: string) => `👔 L’aniversari del Papa (${d})`,
    emma: (d: string) => `👭 L’aniversari de l’Emma (${d})`,
    date: (m: number, d: number) => `${d}/${m}`,
    needCake: 'Necessites un pastís per a la festa. Cou-ne un al forn!',
    done: 'Aquest aniversari ja l’heu celebrat!',
    meTitle: '🎂 La meva festa d’aniversari',
    meText: 'La Mama, el Papa, la teva germaneta, l’Emma i en Jay són aquí! A la taula hi ha un pastís chiffon de maduixa amb les espelmes enceses i tothom et canta. 🎶',
    meWish: '🌟 Tanca els ulls i demana un desig',
    meBlow: 'Bufes les espelmes i tothom aplaudeix! La Mama et dona un regal, el Papa et despentina i la teva germaneta agafa la primera maduixa.',
    meThanks: 'Gràcies a tothom! 💖',
    meVoice: 'Per molts anys, carinyo! Demana un desig!',
    momTitle: '💐 L’aniversari de la Mama',
    momText: 'Has fet d’amagat un pastís chiffon de maduixa i has encès les espelmes. Tothom canta i doneu a la Mama una postal escrita a mà: «Gràcies per cuidar-nos sempre!»',
    momAct: 'Donar a la Mama el primer tros',
    momVoice: 'Gràcies, carinyo! És el millor regal del món!',
    momDone: 'A la Mama se li escapen les llàgrimes i et fa una abraçada molt llarga.',
    dadTitle: '👔 L’aniversari del Papa',
    dadText: 'El Papa ha arribat a temps! La taula és plena de menjar casolà, tothom porta barrets de festa i allà hi ha el teu pastís casolà.',
    dadAct: '«Per molts anys, Papa! Gràcies per esforçar-te tant!»',
    dadVoice: 'Ja, ja! Gràcies! Tots els dies de feina valen la pena per això!',
    dadDone: 'El Papa riu a cor què vols. La família mai no havia estat tan unida!',
    emmaTitle: '👭 El pícnic d’aniversari de l’Emma',
    emmaText: 'Sol sobre la gespa, unes estovalles, llaminadures casolanes i tothom celebrant l’aniversari de l’Emma!',
    emmaAct: 'Donar-li el pastís i una postal',
    emmaVoice: 'Moltíssimes gràcies! Ets el millor del món!',
    emmaDone: 'L’Emma està boja d’alegria!',
  },

  map: {
    names: { town: 'Ciutat', school: 'Institut', home: 'Casa', store: 'Botiga de la cantonada' },
    you: 'Tu',
    goal: 'Objectiu',
    people: 'Gent',
    doors: 'Portes',
  },

  quests: {
    title: 'Missions',
    started: 'Missió nova',
    completed: 'Missió completada',
    active: 'En curs',
    available: 'Disponible',
    done: 'Fetes',
    track: 'Seguir',
    tracking: 'Seguint',
    none: 'Encara no tens missions. Parla amb la gent que trobis!',
    clover: (n: number, total: number) => `🍀 Trèvol de la sort ${n}/${total}`,
    lapsDone: (secs: number) => `🏁 Totes les banderes en ${secs} s! Digues-ho a l’entrenador.`,
    lapsFail: '⏱ S’ha acabat el temps! Parla amb l’entrenador Hsu per tornar-ho a provar.',
    list: {
      atlas: {
        title: 'L’atles perdut',
        desc: 'El gran atles del món de la senyora Wang ha desaparegut de la biblioteca.',
        steps: ['Parlar amb la senyora Wang a la biblioteca', 'Buscar l’atles a l’aula de 2n C', 'Tornar l’atles a la senyora Wang'],
      },
      riceBall: {
        title: 'Un conserge amb gana',
        desc: 'L’oncle Chun s’ha saltat l’esmorzar per vigilar la porta.',
        steps: ['Parlar amb l’oncle Chun a la porta de l’institut', 'Comprar una bola d’arròs a la botiga de la cantonada', 'Portar la bola d’arròs a l’oncle Chun'],
      },
      laps: {
        title: 'Contrarellotge',
        desc: 'L’entrenador Hsu et repta a passar per totes les banderes de la pista en menys d’un minut.',
        steps: ['Parlar amb l’entrenador Hsu al camp d’esports', 'Passar per les 4 banderes en ordre', 'Dir a l’entrenador Hsu que ho has aconseguit'],
      },
      study: {
        title: 'Companys d’estudi',
        desc: 'La Rain vol practicar vocabulari d’anglès amb tu.',
        steps: ['Parlar amb la Rain a la biblioteca', 'Practicar 3 paraules diferents (shadowing)', 'Explicar a la Rain com ha anat'],
      },
      kitten: {
        title: 'On és la Mochi?',
        desc: 'La gateta de l’àvia Lee s’ha escapat pel parc.',
        steps: ['Parlar amb l’àvia Lee al parc', 'Buscar als arbustos del parc: para l’orella per si es mouen les fulles', 'Tornar la Mochi a l’àvia Lee'],
      },
      kite: {
        title: 'Un estel a l’arbre',
        desc: 'L’estel d’en Bo s’ha quedat enganxat a l’arbre gran del barri.',
        steps: ['Parlar amb en Bo al barri', 'Sacsejar l’arbre gran (tres vegades!)', 'Tornar l’estel a en Bo'],
      },
      xiaoyuPicnic: {
        title: 'Un lloc al pícnic',
        desc: 'Dissabte, en Xiaoyu és tot sol al parc.',
        steps: ['Parlar amb en Xiaoyu al parc', 'Preguntar a l’Emma si en Xiaoyu pot venir al pícnic', 'Preguntar a l’Emma si en Xiaoyu pot venir al pícnic'],
      },
      letter: {
        title: 'Enviament especial',
        desc: 'La Mama té una carta per a l’àvia Lee.',
        steps: ['Preguntar a la Mama si necessita ajuda', 'Donar la carta a l’àvia Lee al parc', 'Donar la carta a l’àvia Lee al parc'],
      },
      clovers: {
        title: 'Trèvols de la sort',
        desc: 'Hi ha trèvols de quatre fulles amagats per la ciutat, a l’institut i a casa.',
        steps: ['Estigues atent/a als trèvols que brillen', 'Trobar tots els trèvols de la sort', 'Trobar tots els trèvols de la sort'],
      },
      postcards: {
        title: 'Postals per a l’àvia',
        desc: 'L’àvia Lee mai no va veure la gran ciutat. Porta-li postals de tres llocs de Taipei.',
        steps: ['Parlar amb l’àvia Lee al parc', 'Aconseguir postals a l’Estació Central, el temple de Longshan i la Plaça de la Llibertat', 'Donar les postals a l’àvia Lee'],
      },
      pineapple: {
        title: 'Pastissets de pinya de Taipei',
        desc: 'La mare vol una capsa de pastissets de pinya de Taipei de debò per al berenar amb l’àvia.',
        steps: ['Parlar amb la mare a casa', 'Comprar pastissets de pinya al dependent de Taipei', 'Donar els pastissets de pinya a la mare'],
      },
      elephant: {
        title: 'La foto des de la Muntanya de l’Elefant',
        desc: 'L’Emma vol una foto del Taipei 101 feta des de dalt de la Muntanya de l’Elefant.',
        steps: ['Parlar amb l’Emma a casa', 'Demanar una foto a l’excursionista del mirador de la Muntanya de l’Elefant', 'Ensenyar la foto a l’Emma'],
      },
      mochi: {
        title: 'Mochi de Hualien',
        desc: 'El Bo canvia la seva millor bala per una capsa de mochi tou de Hualien.',
        steps: ['Parlar amb el Bo al barri', 'Comprar mochi a la senyora del mochi a Hualien', 'Donar el mochi al Bo'],
      },
      pebble: {
        title: 'Un còdol de Qixingtan',
        desc: 'A la col·lecció de pedres de la Rain li falta un còdol de la platja de Qixingtan.',
        steps: ['Parlar amb la Rain a la biblioteca', 'Demanar un còdol al pescador de la platja de Qixingtan', 'Donar el còdol a la Rain'],
      },
    },
  },

  library: {
    hello: 'Xxt… benvingut/da a la biblioteca. Pren-te el teu temps.',
    ask: 'Ai, mare. El nostre gran atles del món ha desaparegut: crec que un alumne el va agafar per a Geografia i se’l va deixar en una aula. El podries buscar?',
    accept: 'És clar, el trobaré!',
    hint: 'Els de 2n C han fet Geografia aquest matí. Mira als seus pupitres!',
    thanks: 'L’has trobat! Gràcies. Té, un detallet per al millor ajudant de la biblioteca.',
    found: 'Sota el pupitre, mig amagat darrere una motxilla… l’atles del món!',
    deskNothing: 'Un pupitre amb gargots gravats a la cantonada.',
    shelfText: 'Enciclopèdies, còmics, poesia… els prestatges fan olor de paper vell.',
    read: 'Llegir una estona (+10 d’estudi)',
    readToast: 'Aprens una cosa nova sobre els pops. Tenen tres cors!',
  },

  vending: { text: 'Begudes de colors darrere el vidre. Fa un brunzit suau.', buy: 'Comprar un suc', bought: 'Clonc! Cau un brik de suc.' },
  canteen: {
    text: 'Menú d’avui: arròs, tofu estofat, verdura i sopa.',
    closed: 'La barra del menjador obre d’11:30 a 13:30.',
    lunch: 'Dinar (+30 d’energia)',
    lunchDone: 'Calentó i ben atipador. Ja estàs a punt per a la tarda!',
  },
  busStop: {
    text: 'Línia 8: a l’estació de tren. El proper autobús passa d’aquí a 12 minuts.',
    where: 'Aquí para la línia 8. On vols anar? (Pregunta-ho en anglès: “Does this bus go to the mall?”)',
    stops: { busStopW: 'Oest — botiga, parc i casa', busStop: 'Escola', busStopE: 'Est — poliesportiu i centre comercial' },
    here: '📍 Ets aquí',
    notNow: 'Ara no',
    beep: '🚌 Pip! Passes la targeta EasyCard i puges.',
    arrived: (name: string) => `🚏 ${name}. “Thank you, driver!”`,
    night: 'Ja ha passat l’últim autobús (circulen de 6:00 a 22:00). Toca caminar!',
  },
  mailbox: {
    postcard: 'Una postal de l’avi! «Avui he vist el mar. Porta’t bé, estudia molt i menja’t la verdura».',
    empty: 'La bústia és buida.',
  },
  pond: { text: 'Uns peixos taronja llisquen sota els nenúfars.', feed: 'Donar menjar als peixos (+ànim)', feedToast: 'Els peixos s’arremolinen en un remolí taronja!' },
  bush: { text: 'Un arbust espès i frondós.' },
  kitten: {
    found: 'Hi ha una cosa blanca arraulida entre les fulles… és la Mochi! La gateta miola i et segueix.',
    notHere: 'Apartes les fulles… res, només un escarabat espantat.',
  },
  kite: {
    hello: 'El meu estel és el que vola més alt de tot el carrer!',
    ask: 'El meu estel s’ha quedat enganxat a l’arbre gran! Soc massa baixet per arribar-hi… m’ajudes?',
    accept: 'Deixa-ho per a mi!',
    waiting: 'Sacseja l’arbre amb força! És el gran que hi ha al costat del camí.',
    thanks: 'El meu estel! Ets el millor! Té, uns caramels!',
    after: 'Mira que amunt que va!',
    treeText: 'Un arbre gran i vell amb un tronc ben gruixut.',
    treeAfter: 'Les branques es gronxen suaument. Ja no hi queda cap estel.',
    shakeMore: (n: number) => `Les branques es sacsegen… l’estel trontolla! (${n === 1 ? 'una vegada més' : `${n} vegades més`})`,
    fell: 'Amb una última sacsejada, l’estel baixa voleiant fins a les teves mans!',
  },
  swing: { text: 'Un gronxador amb les cadenes calentes pel sol.', play: 'Gronxar-te una estona', toast: 'Iuhuuu! Més amunt, més amunt!' },
  fridge: { text: 'Sobres, fruita i un flam amb el teu nom.', snack: 'Menjar alguna cosa (+12 d’energia)', snackToast: 'Mmm! El flam de la Mama és el millor.' },
  tv: { text: 'Fan un programa de cuina.', watch: 'Mirar-lo una estona', toast: 'Aprens a tancar empanadetes xineses. Més o menys.' },
  rain: {
    hello: 'Ei! La biblioteca és el meu lloc preferit.',
    offer: 'Vols que siguem companys d’estudi? Practica tres paraules en anglès i després m’expliques com ha anat!',
    accept: 'Fet!',
    waiting: (n: number) => `Com va? Avui has practicat ${n}/3 paraules.`,
    done: 'Increïble! La teva pronunciació millora moltíssim!',
    sat: 'Dissabte al parc! Has vist els peixos de l’estany?',
  },
  coach: {
    hello: 'Amunt aquests genolls, tothom!',
    offer: 'Sembles ràpid/a! Passa per les quatre banderes de la pista, en ordre, en menys d’un minut. A punt?',
    retry: 'Un altre intent? Quatre banderes, un minut!',
    accept: 'A punt!',
    go: '🏁 Som-hi! Segueix les banderes!',
    running: 'Vinga, vinga, vinga! Segueix les banderes!',
    done: 'Quina cursa! Així m’agrada!',
    after: 'Bona feina avui. Recorda estirar!',
  },
  clerk: {
    lines: ['Benvingut/da! Acaben d’arribar boles d’arròs fresques.', 'Hola de nou! Necessites res?', 'Les maduixes són de temporada: dolcíssimes!'],
    shop: '🛒 Anem a comprar',
  },
  grandma: {
    lines: ['Els coloms ja em coneixen. Cru, cru!', 'Quin dia més bonic per passejar.', 'Em recordes el meu nét.'],
    kittenAsk: 'Ai, maco… la meva gateta Mochi s’ha escapat del cistell i s’ha ficat entre els arbustos. Els meus genolls ja no són el que eren…',
    kittenAccept: 'Jo trobaré la Mochi!',
    kittenWaiting: 'Escolta bé: si un arbust es mou, potser la Mochi hi és a dins.',
    kittenThanks: 'Mochi! Ai, gràcies, gràcies! Té, això per les molèsties.',
    letterThanks: 'Una carta de la teva mare? Quin detall. Digues-li que la setmana que ve li portaré empanadetes!',
  },
  cat: { lines: ['Miau~ 🐱', 'Rrrrr…', 'El gat es frega contra la teva cama.', 'El gat et mira i parpelleja a poc a poc. Vol dir «m’agrades».'] },

  talks: caTalks,
  ...caExtra,
  ...caPlaces,
  ...caArcade,
  ...caTreasure,
  ...caTalks3,
  ...caGuide,
  ...caWorld3,
  ...caTrips,
  ...caSky,
  ...caFamily,
  ...caClassroom,
  ...caLife,
  ...caXinyi,
  ...caXimen,
  ...caCks,
  ...caHlcity,
  ...caTaroko,
  ...caStory,
  ...caAirport,
  ...caKaohsiung,
  ...caTainan,
  ...caBarcelona,

  rewards: {
    stars: (n: number) => `+${n}⭐`,
    energy: (n: number) => `+${n}⚡`,
    mood: (n: number) => `+${n}💚`,
    study: (n: number) => `+${n}📄`,
    coins: (n: number) => `+${n}🪙`,
    love: (n: number) => `+${n}💖`,
    got: (what: string) => `Has aconseguit: ${what}`,
  },
};
